import { useQuery } from '@tanstack/react-query';

import { widgetShopApi } from '@entities/widget-shop/api';

export const useGetWidgetsListQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const { data, isSuccess, isPending, isFetching, isLoading, isFetched } = useQuery({
        ...widgetShopApi.getWidgetCardsListQueryOptions(),
        enabled,
    });

    return {
        data,
        isSuccess,
        isPending,
        isFetching,
        isLoading,
        isFetched,
    };
};
